import React, { type ElementType } from 'react';
import { type MessageDescriptor, useIntl } from '@atlassian/jira-intl';

export const useFormattedMessageAndIcon = (message: MessageDescriptor, Icon: ElementType) => {
	const { formatMessage } = useIntl();

	const formattedMessage = formatMessage(message);
	const icon = <Icon spacing="spacious" color="currentColor" aria-hidden="true" />;

	return { formattedMessage, icon };
};
